import { render, staticRenderFns } from "./SearchIndexView.vue?vue&type=template&id=0a55d10a"
import script from "./SearchIndexView.vue?vue&type=script&lang=js"
export * from "./SearchIndexView.vue?vue&type=script&lang=js"
import style0 from "./SearchIndexView.vue?vue&type=style&index=0&id=0a55d10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports